import React, { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Input } from './ui/input';
import { Button } from './ui/button';
import { Ambassador, loadAmbassadors, updateAmbassador } from '../helpers/ambassadorsHelpers';

type Ambassador = {
  id: string;
  name: string;
  avatarUrl: string; // URL 1:1 via GitHub (o usuário irá trocar)
};

const defaultList: Ambassador[] = [
  { id: 'placeholder-1', name: 'Guilherme', avatar_url: '/logo.png', order_index: 0, is_active: true, created_at: '', updated_at: '' },
  { id: 'placeholder-2', name: 'Alexandre', avatar_url: '/logo.png', order_index: 1, is_active: true, created_at: '', updated_at: '' },
  { id: 'placeholder-3', name: 'Lucas', avatar_url: '/logo.png', order_index: 2, is_active: true, created_at: '', updated_at: '' },
];

const SupportPage: React.FC = () => {
  const { isAdmin } = useAuth();
  const [items, setItems] = useState<Ambassador[]>(defaultList);
  const [editingId, setEditingId] = useState<string | null>(null);
  const [url, setUrl] = useState('');

  useEffect(() => {
    const fetch = async () => {
      const list = await loadAmbassadors();
      if (list.length > 0) setItems(list);
    };
    fetch();
  }, []);

  return (
    <div className="flex-1 bg-[#121316] p-8 pt-24">
      <div className="container mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-3xl font-bold text-white mb-2">Suporte Exclusivo</h2>
          <p className="text-gray-400">Fale com nossos embaixadores oficiais</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {items.map((a, idx) => (
            <div key={a.id} className="bg-[#1a1d23] border border-[#1f2329] rounded-2xl p-6 flex flex-col items-center text-center">
              <div className="relative w-40 h-40 rounded-full overflow-hidden border-4 border-[#0FFF55]">
                <img
                  src={a.avatar_url}
                  alt={a.name}
                  className="w-full h-full object-cover"
                  onError={(e) => {
                    const img = e.currentTarget as HTMLImageElement;
                    if (img.dataset.fallbackApplied !== 'true') {
                      img.dataset.fallbackApplied = 'true';
                      img.src = '/logo.png';
                    }
                  }}
                />
              </div>
              <div className="mt-4">
                <div className="text-white text-xl font-semibold">{a.name}</div>
                {/* As informações de contato serão inseridas depois */}
              </div>

              {isAdmin && (
                <div className="w-full mt-4">
                  {editingId === a.id ? (
                    <div className="space-y-2">
                      <Input
                        placeholder="URL da imagem (1:1)"
                        value={url}
                        onChange={(e) => setUrl(e.target.value)}
                        className="bg-[#0f1114] border-[#1f2329] text-white"
                      />
                      <div className="flex gap-2">
                        <Button
                          className="flex-1 bg-[#0FFF55] text-black hover:bg-[#0dd149]"
                          onClick={() => {
                            const nextUrl = url.trim();
                            // Persistir no banco
                            updateAmbassador(a.id, { avatar_url: nextUrl }).then((saved) => {
                              if (saved) {
                                const next = [...items];
                                next[idx] = saved;
                                setItems(next);
                              }
                              setEditingId(null);
                              setUrl('');
                            });
                          }}
                        >
                          Salvar
                        </Button>
                        <Button variant="outline" className="flex-1" onClick={() => { setEditingId(null); setUrl(''); }}>Cancelar</Button>
                      </div>
                    </div>
                  ) : (
                    <Button variant="outline" className="w-full" onClick={() => { setEditingId(a.id); setUrl(a.avatar_url || ''); }}>
                      Editar imagem
                    </Button>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SupportPage;


